import React from "react";
import FileUploader from "../../components/ContactService/FileUploader";
import { useFormContext } from "react-hook-form";
import { connect, useDispatch } from "react-redux";
import { uploadImage } from "../../store/contact-service/actions";
import { RootState } from "../../store/root-reducer";

function UploadDocument({ documents }) {
  const { control } = useFormContext();
  const dispatch = useDispatch();

  return (
    <div>
      <FileUploader
        control={control}
        name="invoiceImage"
        label="Invoice Document/Image"
        uploadedFiles={documents.invoice}
        // onFileSelect={(files) =>
        //   dispatch(uploadImage({ fieldName: "invoice", files }))
        // }
        onFileSelect={() => {}}
        note="The invoice or receipt should show the purchase of a MyProtectAll protection plan."
        required
      />
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  documents: state?.contactService?.documents || {},
});

export default connect(mapStateToProps)(UploadDocument);
